export const TAXPAYER_SCHEDULE_VIEW_RANGE_TYPE = [
  { label: "담당자", value: "manager" },
  { label: "전체", value: "all", },
  { label: "나만보기", value: "me" },
];